export const presetData = [
	{
		id: 'square',
		label: 'square',
		aspectRatio: 1
	},
	{
		id: '16-9',
		label: '16:9',
		aspectRatio: 16/9
	},
	{
		id: '9-16',
		label: '9:16',
		aspectRatio: 9/16
	},
	{
		id: '4-3',
		label: '4:3',
		aspectRatio: 4/3
	},
	{
		id: '3-4',
		label: '3:4',
		aspectRatio: 3/4
	},
	{
		id: 'open-graph-image',
		label: 'Open Graph Image',
		width: 1200,
		height: 630,
		aspectRatio: 1200/630
	},
	{
		id: 'instagram-feed',
		label: 'Instagram Post',
		width: 1080,
		height: 1080,
		aspectRatio: 1080/1080
	},
	{
		id: 'twitter-feed',
		label: 'Twitter Post',
		width: 1200,
		height: 675,
		aspectRatio: 1200/675
	},
	{
		id: 'facebook-feed',
		label: 'Facebook Post',
		width: 1200,
		height: 630,
		aspectRatio: 1200/630
	}
];